module.exports = __webpack_public_path__ + "img/f3-card-4.6f3c3f27.png";